import CashTxnForm from "../CashTxnForm";

const MoneyIn = () => <CashTxnForm type="in" />;

export default MoneyIn;
